import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_IMPORT_ADS_BLOCK } from "@assets/svgs/ICON_IMPORT_ADS_BLOCK.svg";
import { Icon } from "@components/Icon";
import { MiniPreviewStreaming } from "@components/MiniPreviewComponents/MiniPreviewStreaming";
import { Audio } from "@components/PreviewComponents/Audio";
import { Image } from "@components/PreviewComponents/Image";
import { ScrollingText } from "@components/PreviewComponents/ScrollingText";
import { Streaming } from "@components/PreviewComponents/Streaming";
import { Video } from "@components/PreviewComponents/Video";
import { Website } from "@components/PreviewComponents/Website";
import { YoutubeLive } from "@components/PreviewComponents/YoutubeLive";
import { COLOR_WHITE } from "@static/COLORS";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;

export const RenderInnerMediaBlock = ({
  height,
  width,
  firstMediaInBlocks,
  index,
}) => {
  return (
    <Container>
      {_.isNil(firstMediaInBlocks) && (
        <Icon width={"20%"} height={"20%"}>
          <ICON_IMPORT_ADS_BLOCK fill={COLOR_WHITE} />
        </Icon>
      )}
      {!_.isNil(firstMediaInBlocks) &&
        (() => {
          const mediaType = _.get(firstMediaInBlocks, ["type"]);
          const attribute = _.get(firstMediaInBlocks, ["attribute"]);
          const id = _.get(firstMediaInBlocks, ["id"]);
          switch (mediaType) {
            case "image":
              return <Image key={id} attribute={attribute} />;
            case "video":
              return (
                <Video
                  key={id}
                  attribute={attribute}
                  mute={true}
                  controls={true}
                  width={width}
                  height={height}
                />
              );
            case "audio":
              return (
                <Audio
                  key={id}
                  attribute={attribute}
                  controls={true}
                  playing={false}
                />
              );
            case "website":
              return <Website key={id} attribute={attribute} />;
            case "youtube-live":
              return (
                <YoutubeLive
                  key={id}
                  attribute={attribute}
                  playing={false}
                  width={"100%"}
                  height={"100%"}
                />
              );
            case "running-text":
              return <ScrollingText key={id} attribute={attribute} />;

            case "video-streaming":
              // return <Streaming key={id} attribute={attribute} />;
              return <MiniPreviewStreaming key={id} path={attribute?.path} />;
            default:
              return null;
          }
        })()}
    </Container>
  );
};
